import React, { useState } from "react";
import ReactQuill from "react-quill";
import Select from "react-select"; // Ensure you're importing the react-select component
import { Link } from "react-router-dom";
import Header from "../../../header/header";
import Navvbar from "../../../header/Navvbar";
import Footer from './../../../footer';
const AddButton = () => {
  // State for dropdown and text editor
  const [selectedOption, setSelectedOption] = useState(null);
  const [description, setDescription] = useState("");
  const [formData, setFormData] = useState({
    title: "",
    teaser: "",
    startDate: "",
    endDate: "",
    limitToPractices: "",
    adLinksTo: "internalPage", // Default value
    description: "",
    externalLink: "",  // Store external link URL
  });

  // Options for dropdown
  const options = [
    { value: "internalPage", label: "Internal Page" },
    { value: "externalLink", label: "External Link" },
  ];

  // Handle input changes for text fields
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle changes for ReactQuill editor
  const handleQuillChange = (value) => {
    setDescription(value);
    setFormData((prevData) => ({
      ...prevData,
      description: value,  // Sync the description state with formData
    }));
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

  };

  const styles = {
    form: {
      maxWidth: "1100px",
      fontSize: "17px",
      padding: "20px",
      borderRadius: "5px",
      fontFamily: "Arial, sans-serif",
   
    },
    sectionTitle: {
  
      color: "black",
      backgroundColor: "#f0f0f0",
      borderTop: "2px solid #004aad",
      marginBottom: "10px",
      paddingBottom: "5px",
    },
    label: {
      fontWeight: "bold",
      marginBottom: "5px",
      display: "block",
      marginLeft:"10px"
    },
    input: {
      width: "25%",
      padding: "8px",
      margin: "8px 0",
      border: "1px solid #ccc",
      borderRadius: "4px",
      boxSizing: "border-box",
      marginLeft:'10px'
    },
    select: {
      width: "25%",
      padding: "8px",
      margin: "8px 0",
      border: "1px solid #ccc",
      borderRadius: "4px",
      boxSizing: "border-box",
      marginLeft:"10px"
    },
    selectDropdown: {
      width: "35%",  // Set the specific width for the Select dropdown
      marginLeft:'10px'
    },
    button: {
      padding: "10px 20px",
      backgroundColor: "#004aad",
      color: "white",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
      marginLeft:'10px'
    },
    error: {
      color: "#004aad",
    },
  };

  return (
    <>
      <Header />
      <Navvbar/>
      <br />
      <div className="container">
        <div className="row">
          {/* Sidebar */}
              <div className="col-md-2" style={{ borderRight: '1px solid #004aad'  }}>
                              <h3>Promotions</h3>
                              <div>
                                  <div style={{ marginBottom: "10px" }}>
                                      <Link to="/Websites" style={{ textDecoration: 'none',color: '#004aad',  fontWeight: '500',marginBottom: '10px',marginLeft:"15px"}}>DDX Websites</Link>
                                  </div>
                                  <div style={{ marginBottom: "10px" }}>
                                      <Link to="/Ad" style={{ textDecoration: 'none',color: '#004aad',  fontWeight: '500',marginBottom: '10px',marginLeft:"15px"}}>DDX Ads</Link>
                                  </div>
                                  <div style={{ marginBottom: "10px" }}>
                                      <Link to="/Coupon" style={{ textDecoration: 'none',color: '#004aad',  fontWeight: '500',marginBottom: '10px',marginLeft:"15px"}}>DDX Coupons</Link>
                                  </div>
                                  <div style={{ marginBottom: "10px" }}>
                                      <Link to="/Widget" style={{ textDecoration: 'none',color: '#004aad',  fontWeight: '500',marginBottom: '10px',marginLeft:"15px"}}>Widgets</Link>
                                  </div>
                                  <div style={{ marginBottom: "10px" }}>
                                      <Link to="/action" style={{ textDecoration: 'none',color: '#004aad',  fontWeight: '500',marginBottom: '10px',marginLeft:"15px"}}>Links</Link>
                                  </div>
                                  <div style={{ marginBottom: "10px" }}>
                                      <Link to="/DDxAccount" style={{ textDecoration: 'none',color: '#004aad',  fontWeight: '300',marginBottom: '10px',marginLeft:"15px",fontSize:"15px"}}>DDX Account Onboarding</Link>
                                  </div>
                              </div>
                          </div>

          <form onSubmit={handleSubmit} style={styles.form}>
            <h3>New DDX ADS</h3>

            {/* Overview Section */}
            <h3>Overview</h3>
            <div  style={styles.sectionTitle}>

            <div>
              <label style={styles.label}>
                Title <span style={styles.error}>*</span>
              </label>
              <input
                type="text"
                name="title"
                value={formData.title} // Set value from formData
                onChange={handleChange}
                required
                style={styles.input}
              />
            </div>

            <div>
              <label style={styles.label}>
                Teaser <span style={styles.error}>*</span>
              </label>
              <input
                type="text"
                name="teaser"
                value={formData.teaser} // Set value from formData
                onChange={handleChange}
                required
                style={styles.input}
              />
            </div>

            <div>
              <label style={styles.label}>Start Date
                <span style={styles.error}>*</span>
              </label>
              <input
                type="date"
                name="startDate"
                value={formData.startDate} // Set value from formData
                onChange={handleChange}
                style={styles.input}
              />
            </div>

            <div>
              <label style={styles.label}>End Date
                <span style={styles.error}>*</span>
              </label>
              <input
                type="date"
                name="endDate"
                value={formData.endDate} // Set value from formData
                onChange={handleChange}
                style={styles.input}
              />
            </div>

          <div>    
              <div>
                <label style={styles.label}>
                  Limit to Practices 
                </label>
                <select
                  name="limitToPractices"
                  value={formData.limitToPractices} // Set value from formData
                  onChange={handleChange}
                  style={styles.select}
                >
                  <option value="Practice 1">Practice 1</option>
                  <option value="Practice 2">Practice 2</option>
                  <option value="Practice 3">Practice 3</option>
                </select>
              </div>
              </div>
            </div>
            <br />

            {/* Content Section */}
            <h3 >Content</h3>

            <div style={styles.sectionTitle}><br/>
              <h4 style={{ fontWeight: "bold", fontSize: "18px",marginLeft:'10px' }}>Ad Links To
              <span style={styles.error}>*</span>
              </h4>
              <Select
                options={options}
                value={selectedOption}
                onChange={(selected) => {
                  setSelectedOption(selected);
                  // Update formData to store selected option
                  setFormData({
                    ...formData,
                    adLinksTo: selected.value, // Store the selected option (internalPage, externalLink)
                  });
                }}
                placeholder="Select an option"
                styles={{ control: (base) => ({ ...base, ...styles.selectDropdown }) }} // Applying custom width to dropdown
              />
              <br />

              {/* Conditionally render URL input for External Link option */}
              {formData.adLinksTo === "externalLink" && (

                <div>
                  <label style={styles.label}>URL</label>
                  <input
                    type="url"
                    name="externalLink"
                    value={formData.externalLink} // Bind the value to formData.externalLink
                    onChange={handleChange}
                    placeholder=""
                    style={styles.input}
                  />
                </div>
              )}

              {/* Conditionally render Description Section (hide for External Link) */}
              {formData.adLinksTo !== "externalLink" && (
                <>
                  <p style={{ marginTop: "20px" }}>
                    Please provide a description of the item or event that you are advertising.
                    This content will be displayed on the full ad page.
                  </p>

                  <ReactQuill
                    theme="snow"
                    value={description} // Set value from description state
                    onChange={handleQuillChange}
                    placeholder="Enter your ad description here..."
                    style={{ marginTop: "10px", height: "200px",  }}
                  />
                </>
              )}

              <br />
              <br />
              <br />
              <br />

              <button type="submit" style={styles.button}>
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>

      <br />
      <br />
      <br />
      <br />
      <div className="container">
        <Footer />
      </div>
    </>
  );
};

export default AddButton;
